import { HubConnection, HubConnectionBuilder , LogLevel } from "@microsoft/signalr";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AlertNotificationDispatch as myNotificationDispatch} from "Store/AlertNotification/AlertNotificationDispatch";
import store from "redux/store";

const signalRHubUrl: string =
    process.env.REACT_APP_WEBAPP_API_BASE_URL || "https://localhost";

const useSignalR = (userId: any) => {
  const [connection, setConnection] = useState<null | HubConnection>(null);
  const dispatch = useDispatch();
  const dispatchSetMyAlertDetails = myNotificationDispatch.dispatchSetMyAlertNotificationDetails(dispatch);

  const onNewNotificationAndAlert = (newData: any) => {
    const myAlertDetails =
      store.getState()?.AlertAndNotificationsReducer?.myAlertNotificationDetails || {};

    const alertAndNotificationsExt: any = { ...myAlertDetails };
    alertAndNotificationsExt.notificationCount =
      alertAndNotificationsExt.notificationCount
        ? alertAndNotificationsExt.notificationCount + newData.notificationCount
        : newData.notificationCount;
    alertAndNotificationsExt.alertCount = alertAndNotificationsExt.alertCount
      ? alertAndNotificationsExt.alertCount + newData.alertCount
      : newData.alertCount;
    let notificationDetails: any = alertAndNotificationsExt
      ?.notificationDetails?.length
      ? [
          ...(newData.notificationDetails || []),
          ...alertAndNotificationsExt.notificationDetails,
        ]
      : [...(newData.notificationDetails || [])];

      alertAndNotificationsExt.notificationDetails = notificationDetails.sort(function(a :any, b: any) {
        return +new Date(b.created) - +new Date(a.created) ;
      });

      let alertDetails: any = alertAndNotificationsExt
      ?.alertDetails?.length
      ? [
          ...(newData.alertDetails || []),
          ...alertAndNotificationsExt.alertDetails,
        ]
      : [...(newData.alertDetails || [])];

      alertAndNotificationsExt.alertDetails = alertDetails.sort(function(a :any, b: any) {
        return +new Date(b.created) - +new Date(a.created) ;
      });

    dispatchSetMyAlertDetails(alertAndNotificationsExt);
  };

  const watcherMethods = () => {
    if (connection?.connectionId) {
      connection.invoke(
        "sendConnectionId",
        connection.connectionId,
        String(userId)
      );
      connection.on("ReceiveNotification", onNewNotificationAndAlert);
    }
  };

  const stopConnection = () => {
    if (connection) {
      connection.stop();
    }
  };

  useEffect(() => {
    if (userId) {
      const connect = new HubConnectionBuilder()
        .withUrl(`${signalRHubUrl}chat`)
        .withAutomaticReconnect()      
        .configureLogging(LogLevel.Debug)  
        .build();

      setConnection(connect);
    }
  }, [userId]);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then(watcherMethods)
        .catch((error: any) => console.log(error));
    }

    return stopConnection;
  }, [connection]);
};

export default useSignalR;
